export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5219.63c1cf4c.jpg";